import React, { useState } from 'react'
import useTrans from 'hooks/useTrans'
import { PaginaType } from 'utils/types'
import { MyOptinsFormCard, MyAccountLayout, Page } from 'components/organisms'
import styles from './MyAccountPreferenzeTemplate.module.sass'

interface IBrandOptin{
    node: {
        name: string
        image: string
        value: boolean
        optinName: string
    }
}

interface Props {
  pagina: PaginaType
  optins?: {
    optinBrands: IBrandOptin[]
    optinMarketing: string
    optinProgramMarketing2: string
  }
}

const MyAccountPreferenzeTemplate = ({ optins, pagina }: Props) => {
  const t = useTrans()

  return (
    <Page pagina={pagina} item={{}}>
      <MyAccountLayout
        titolo={pagina.titolo}
        descrizione={pagina.descrizione}
        menuActiveItemKey="privacy"
        backLink={false}
      >
          <MyOptinsFormCard dati={{ ...optins }}/>
      </MyAccountLayout>
    </Page>
  )
}

export default MyAccountPreferenzeTemplate
